<template>
  <div class="content content-narrow plant-detail">
    <div class="col-12 gt-details">
      <div class="block">
        <div v-if="showLoader" class="overlay"></div>
        <hash-loader v-if="showLoader" class="hash-icon table-hash-icon" color="#5C7FD1" loading="loading" size="40" sizeUnit="px"></hash-loader>
        <div class="block-header bg-primary">
          <h3 class="block-title text-white"><i class="fa fa fa-cut text-white"></i> Harvest Details</h3>
          <div class="blok-title text-white text-right">
            <router-link to="/harvests" title="Go back" class="js-tooltip-enabled text-white">
              <i class="fa fa-angle-double-left text-white"></i> Back
            </router-link>
          </div>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.Id }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.Name }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Type</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.HarvestType }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Patient License Number</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(harvest.PatientLicenseNumber) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Current Weight</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(harvest.CurrentWeight) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Total Waste Weight</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.TotalWasteWeight }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Plant Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.PlantCount }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Total Wet Weight</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.TotalWetWeight }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Total Restored Weight</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.TotalRestoredWeight }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Packaged Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.PackageCount }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Total Packaged Weight</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.TotalPackagedWeight }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Unit Of Weight Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.UnitOfWeightName }}</div>
            <div class="col-12 border-top"></div> 
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Lab Testing State</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.LabTestingState }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Lab Testing State Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(harvest.LabTestingStateDate) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Is On Hold</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.IsOnHold }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Harvest Start Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(harvest.HarvestStartDate) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Is On Hold</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getValue(harvest.IsOnHold) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Finished Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(harvest.FinishedDate) }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Archived Date</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(harvest.ArchivedDate) }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Last Modified</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ getDate(harvest.LastModified) }}</div>
          </div>
        </div>
        <div class="block-header bg-primary">
          <h3 class="block-title text-white"><i class="fa fa-cannabis"></i> Strain</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Source Strain Count</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.SourceStrainCount }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Source Strain Names</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.SourceStrainNames }}</div>
            <div class="col-12 border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Strains</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
              <span v-for="(strain, index) in harvest.Strains" :key="index">{{ strain.Name }}</span>
            </div>
            <div class="col-12 hidden-border border-top"></div>
          </div>
        </div>
        <div class="block-header bg-primary">
          <h3 class="block-title text-white"><i class="fa fa-door-open"></i> Drying Room</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="row">
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Room Id</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.DryingRoomId  }}</div>
            <div class="col-12 hidden-border border-top"></div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 font-w600 font-size-sm">Room Name</div>
            <div class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">{{ harvest.DryingRoomName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { helper } from '@/helper.js';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
Vue.use(VueSpinners);

export default {
  name: 'HarvestDetails',
  data() {
    return {
      harvest: {
        Id: 0,
        Name: 'null',
        HarvestType: 'null',
        SourceStrainCount: 0,
        SourceStrainNames: null,
        Strains: [],
        DryingRoomId: null,
        DryingRoomName: null,
        PatientLicenseNumber: '',
        CurrentWeight: 0,
        TotalWasteWeight: 0.0,
        PlantCount: 0,
        TotalWetWeight: 0.0,
        TotalRestoredWeight: 0.0,
        PackageCount: 0,
        TotalPackagedWeight: 0.0,
        UnitOfWeightName: null,
        LabTestingState: '',
        LabTestingStateDate: null,
        IsOnHold: false,
        HarvestStartDate: null,
        FinishedDate: null,
        ArchivedDate: null,
        LastModified: null
      },
      showLoader: false
    };
  },
  mounted() {
    let vm = this;
    vm.showLoader = true;
    helper.sendPostRequest('/harvests/get', { id: vm.$route.params.id})
      .then((data) => {
        if (data.status === 'success') {
          vm.harvest = data.data;
        } else {
          vm.$router.push('/plantbatch');
        }
        vm.showLoader = false;
      });
  },
  components: {
    HashLoader
  },
  methods: {
    getDate(dateText) {
      if (dateText === '') {
        return 'null';
      }
      let date = new Date(dateText).toISOString().substr(0, 19).replace('T', ' ');
      return date;
    },
    getValue(value) {
      if (!value) {
        return 'null';
      }
      return value;
    }
  }
};
</script>
<style>
.gt-details .block {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// source/components/HarvestDetails.vue